<template>
  <div class="cc-container">
     <HelloWorld />
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
export default {
components: {
  HelloWorld,
},
data() {
  return {
    componentInfo: {
      
      component: "component-cc-plug",
      
      // 组件显示名称：建议精简易懂，6个字以内
      compName: "cc-plug",
      
      // 组件功能描述：建议写清核心能力，50字以内
      compDesc: "请填写组件功能描述",
    }
  };
},
};
</script>
<style lang="scss" scoped>
.cc-container {
  text-align: center;
  padding: 8px;
}
</style>